import Vue from 'vue'
import App from './App.vue'
import { createStore } from './store'
import { createRouter } from './router'
import { sync } from 'vuex-router-sync'
import titleMixin from './util/title'
import * as filters from './util/filters'
import { config } from "./config";
import VueAnalytics from 'vue-analytics'
import uuid from 'uuid/v4'
import validate from 'uuid-validate'
import * as firebase from "firebase/app";
import firebaseConfig from './firebaseConfig.js'

if (!firebase.apps.length) firebase.initializeApp(firebaseConfig)
// import firebase from "./firebaseConfig.js";

Vue.mixin(titleMixin)

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// Expose a factory function that creates a fresh set of store, router,
// app instances on each call (which is called for each SSR request)
export function createApp () {
  // create store and router instances
  const store = createStore()
  const router = createRouter()

  // sync the router with the vuex store.
  // this registers `store.state.route`
  sync(store, router)

  // create the app instance.
  // here we inject the router, store and ssr context to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  // 
  Vue.prototype.$config = config;

  const bus = new Vue();
  Vue.prototype.$bus = bus;

  if(process.env.NODE_ENV === "production") {
    // production config
    Vue.use(VueAnalytics, {
      id: 'UA-122877476-2',
      router
    })
  } else {
    // dev config
    Vue.use(VueAnalytics, {
      id: 'UA-122877476-5',
      router
    })
  }


  const app = new Vue({
    router,
    store,
    mounted: function() {
      if (!localStorage.getItem('webSessionId') || !validate(localStorage.getItem('webSessionId'), 4)) {
        localStorage.setItem('webSessionId', uuid())
      }
      firebase.analytics() //initialize analytics
    },
    render: h => h(App)
  })

  // expose the app, the router and the store.
  // note we are not mounting the app here, since bootstrapping will be
  // different depending on whether we are in a browser or on the server.
  return { app, router, store }
}



// WEBPACK FOOTER //
// src/app.js